export default __webpack_public_path__ + "static/media/3.26cceb0f.gif";